module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSemiBold.445f38d.woff";